import { render, staticRenderFns } from "./EzFlashMessage.vue?vue&type=template&id=71215062&scoped=true&"
import script from "./EzFlashMessage.vue?vue&type=script&lang=js&"
export * from "./EzFlashMessage.vue?vue&type=script&lang=js&"
import style0 from "./EzFlashMessage.vue?vue&type=style&index=0&id=71215062&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71215062",
  null
  
)

export default component.exports